(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-arrivals"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('carousel-arrivals')) {
  customElements.define('carousel-arrivals', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.c-arrivals__track');
      this.group = this.querySelector('.c-arrivals__group');
      this.viewport = this.querySelector('.c-arrivals__viewport');
      this.toggle = this.querySelector('.c-arrivals__toggle');
      this.originals = Array.from(this.group.children).map(item => item.cloneNode(true));
      this.paused = this.dataset.autoplay !== 'true';
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updatePause();
      });
      this.updatePause();
      this.observer = new ResizeObserver(() => this.fit());
      this.observer.observe(this.viewport);
      document.fonts.ready.then(() => { if (this.isConnected) this.fit(); });
    }
    disconnectedCallback() { this.observer?.disconnect(); this.initialized = false; }
    updatePause() {
      this.toggleAttribute('data-paused', this.paused);
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause);
    }
    fit() {
      const width = this.viewport.clientWidth;
      const contentWidth = Array.from(this.group.children).slice(0, this.originals.length).reduce((total, item) => total + item.getBoundingClientRect().width, 0);
      const layoutKey = width + ':' + Math.round(contentWidth * 100);
      if (this.hasAttribute('data-ready') && this.layoutKey === layoutKey) return;
      this.layoutKey = layoutKey;
      this.group.querySelectorAll('[data-repeat]').forEach(item => item.remove());
      this.track.querySelectorAll('.c-arrivals__group[aria-hidden]').forEach(group => group.remove());
      if (!this.group.scrollWidth) return;
      let safety = 0;
      while (this.group.scrollWidth < this.viewport.clientWidth + 1 && safety++ < 12) {
        this.originals.forEach(original => {
          const item = original.cloneNode(true);
          item.dataset.repeat = '';
          item.setAttribute('aria-hidden', 'true');
          item.removeAttribute('data-shopify-editor-block');
          item.querySelectorAll('a').forEach(a => a.tabIndex = -1);
          this.group.append(item);
        });
      }
      const clone = this.group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(item => item.removeAttribute('data-shopify-editor-block'));
      clone.querySelectorAll('a').forEach(a => a.tabIndex = -1);
      this.track.append(clone);
      this.toggle.hidden = false;
      this.setAttribute('data-ready', '');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
  if (window.location.pathname.split('/').filter(Boolean).pop() === 'proiector-de-povesti-mici-aventuri') {
    document.querySelectorAll('[data-carousel-story-recovery]').forEach((element) => {
      element.hidden = false;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
